import { useEffect, useState } from 'react';
import Routes from 'routes/Routes';
import { useAuth0 } from '@auth0/auth0-react';
import PageLoader from 'utils/sharedComponents/PageLoader';
import { hotjar } from 'react-hotjar';
import 'App.css';
import 'assets/css/common-style.css';
import 'assets/css/custom-style.css';
import 'assets/css/custom-dev-style.css';
import 'assets/css/responsive.css';
import { auth0Security } from 'utils/auth/auth0.security';
import AppLayoutSb from 'layout/skybox/AppLayoutSb';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { actions, dataSource, toggleData } from 'models/Slices/GlobalSlice';
import AppLayoutSh from 'layout/stubHub/AppLayoutSh';
import { useLocation } from 'react-router';

const App = () => {
  const { isLoading, user, getAccessTokenSilently } = useAuth0();
  const location = useLocation();
  const [isHotjarInitialized, setIsHotjarInitialized] = useState(false);
  const path = location.pathname;
  const dataSourcePath = path.split('/')[1]

  const dispatch = useAppDispatch();
  const _dataSource = useAppSelector(dataSource);

  useEffect(() => {
    dispatch(actions.getCalendarPresetsAction());
  });
  
  useEffect(() => {
    if(dataSourcePath){
      if(dataSourcePath === 'skybox') dispatch(toggleData('skyBox'))
      else if(dataSourcePath === 'stubhub')  dispatch(toggleData('stubHub'))
    }
  })

  useEffect(() => {
    if (process.env.REACT_APP_HOTJAR_ID && process.env.REACT_APP_HOTJAR_SV) {
      hotjar.initialize(
        parseInt(process.env.REACT_APP_HOTJAR_ID),
        parseInt(process.env.REACT_APP_HOTJAR_SV),
      );
      setIsHotjarInitialized(true);
      console.log('Hotjar initialized');
    } else {
      console.log('Hotjar not initialized');
    }
  }, []);

  useEffect(() => {
    if (isHotjarInitialized && !isLoading && user?.sub) {
      hotjar.identify(user.sub, {
        email: user.email ? user.email : '',
        name: user.name ? user.name : '',
      });
      console.log('Hotjar identified');
    }
  }, [isHotjarInitialized, isLoading, user]);

  if (isLoading) {
    return <PageLoader />;
  }

  auth0Security.setAccessTokenSilently(getAccessTokenSilently);

  return _dataSource === 'skyBox' ? (
    <AppLayoutSb>
      <Routes />
    </AppLayoutSb>
  ) : (
    <AppLayoutSh>
      <Routes />
    </AppLayoutSh>
  );
};

export default App;
